import Feature from 'ol/Feature';

export class DrawingChanges {
  add: Feature[]
  update: Feature[];
  delete: string[];
}
